import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store";
import { addToken, signIn, signOut } from "redux/slices/auth";

export default function useAuth() {
  const dispatch = useDispatch();
  const { user, supplier } = useSelector((state: RootState) => state.auth);

  const logIn = useCallback(
    function (user: User, supplier: Supplier, token?: string) {
      if (token) {
        dispatch(addToken(token));
        localStorage.setItem("token-supplier-v1", token);
      }
      if (user) dispatch(signIn({ user, supplier }));
    },
    [dispatch]
  );

  const logOut = useCallback(() => {
    localStorage.clear();
    dispatch(signOut());
  }, [dispatch]);

  const updateToken = useCallback(
    (token: string) => {
      dispatch(addToken(token));
    },
    [dispatch]
  );
  return { user, logIn, logOut, updateToken, supplier };
}
